import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { moduleManager } from 'redux/action/modules';
import { TableSearchInput } from './GasExcelSearchBar.css.js';

const SearchModule = ({ updateSearchMap }) => {
  const dispatch = useDispatch();
  const loginStatus = useSelector((store) => store.loginManager.status);
  const modules = useSelector((store) => store.modules.module); // 장치 데이터

  if (!modules) {
    dispatch(moduleManager('', loginStatus.authIdx));
    return null;
  }

  return (
    <div className="search-condition col-xl-3 col-sm-3">
      <label>장치</label>
      <TableSearchInput
        className="table-search-input up-check"
        onChange={({ target }) => {
          updateSearchMap('moduleIdx', target.value.split('_')[0]);
          updateSearchMap('moduleScn', target.value.split('_')[1]);
        }}
      >
        <option value="0_0">장치를 선택해주세요</option>
        {modules
          .filter((d) => d.moduleScn === '0' || d.moduleScn === '4' || d.moduleScn === '6')
          .map((d) => {
            return (
              <option key={d.moduleIdx} value={`${d.moduleIdx}_${d.moduleScn}`}>
                {d.modelNm}
              </option>
            );
          })}
      </TableSearchInput>
    </div>
  );
};

export default React.memo(SearchModule);
